import React, { useState } from 'react';
import cx from 'classnames';
import { ReactComponent as AIIcon } from '../../../../../assets/img/icons/assistant/AI.svg';
import { RootPortal, SideModal } from '../../../../../components';
import Markdown from '../../../../../components/Markdown/Markdown';
import useIsMobile from '../../../../../hooks/useIsMobile';
import useRestaurantUuid from '../../../../../hooks/store/useRestaurantUuid';
import { useNotificationContext } from '../../../../../contexts/NotificationContext';
import { useLazyProdRecAIReport } from '../../../../../api/productionQueue';

export const AIReportButton = ({ uuid }) => {
  const isMobile = useIsMobile();
  const restaurantUuid = useRestaurantUuid();
  const [recAIReport, setRecAIReport] = useState(null);

  const [getAIReport, { isFetching }] = useLazyProdRecAIReport();
  const { addNotification } = useNotificationContext();

  const fetchAIReport = () => {
    getAIReport({ restaurantUuid, uuid, ts: Date.now() })
      .unwrap()
      .then(res => {
        setRecAIReport(res);
      })
      .catch(() => {
        addNotification('danger', 'Unable to load AI report', 'Error', 3000);
      });
  };

  return (
    <>
      <button
        style={{ padding: 10 }}
        className="custom-table__menu-cell__button text-tertiary"
        onClick={fetchAIReport}
        disabled={isFetching}
      >
        <AIIcon />
      </button>

      {recAIReport && (
        <RootPortal>
          <SideModal
            title="AI Report"
            onCancel={() => setRecAIReport(null)}
            className={cx('pcs-recs-ai-report', { 'pcs-recs-ai-report-desktop': !isMobile })}
            modalBody={
              <div className="pcs-recs-ai-report-body">
                <div className="pcs-recs-ai-report-content">
                  <Markdown text={recAIReport.update_info} />
                </div>
              </div>
            }
            customButtons={false}
          />
        </RootPortal>
      )}
    </>
  );
};
